import Cookie from 'js-cookie';
import superagent from 'superagent';
import { AUTH_API_SETTINGS } from 'services/App/App.constants';

export default class ReceiptDelete {
  delete(id) {
    // get this every time since the session/settings/token always change
    const accessToken = Cookie.get('accessToken');
    const country = 'JP';

    return new Promise((resolve, reject) => {
      superagent
        .delete(`${AUTH_API_SETTINGS[country].API_BASE_URL}/v8/api/uploads/${id}.json`)
        .set('authorization', `Bearer ${accessToken}`)
        .set('x-api-version', 6)
        .end(async (error, response) => {
          if (error || response.status !== 200) {
            console.error(`Failed to get delete receipt: ${error}`);

            return reject();
          }

          return resolve();
        });
    });
  }
}
